// import moment from 'moment-timezone';
import funnelsApi from '../../api/funnels';
import {
	getAxiosErrorMessage,
} from '../../lib/helper';
// import { formatDate, groupBy } from '../../lib/helper';

const SET_FUNNEL_PAGES = 'SET_FUNNEL_PAGES';
const SET_IS_FETCHING_FUNNEL_PAGE = 'SET_IS_FETCHING_FUNNEL_PAGE';
const SET_IS_FETCHED_FUNNEL_PAGE = 'SET_IS_FETCHED_FUNNEL_PAGE';
const CLEAR_FUNNEL_PAGE = 'CLEAR_FUNNEL_PAGE';
const RESET_FUNNEL_PAGES = 'RESET_FUNNEL_PAGES';
const EDIT_FUNNEL_PAGES = 'EDIT_FUNNEL_PAGES';
const DELETE_FUNNEL_PAGE = 'DELETE_FUNNEL_PAGE';
const APPEND_FUNNEL_PAGE = 'APPEND_FUNNEL_PAGE';
const APPEND_NEW_FUNNEL_PAGE = 'APPEND_NEW_FUNNEL_PAGE';
const SET_FUNNEL_PAGE = 'SET_FUNNEL_PAGE';
const ADD_FUNNEL_PAGE = 'ADD_FUNNEL_PAGE';
const SET_IS_ALL_FUNNEL_PAGE = 'SET_IS_ALL_FUNNEL_PAGE';

// page editor
const SET_PAGE_EDITOR_HISTORY = 'SET_PAGE_EDITOR_HISTORY';
const SET_DRAGGED_ELEMENT = 'SET_DRAGGED_ELEMENT';
const SET_IS_DRAGGING = 'SET_IS_DRAGGING';
const SET_DROP_AREA = 'SET_DROP_AREA';
const SET_FONT_FAMILIES = 'SET_FONT_FAMILIES';
const SET_SECTIONS_COUNT = 'SET_SECTIONS_COUNT';
const SET_ACTION_ELEMENT = 'SET_ACTION_ELEMENT';
const APPEND_HISTOY = 'APPEND_HISTOY';

const state = {
	allFunnelPages: [],
	isFetchingFunnelPage: false,
	isFetchedFunnelPage: false,
	isAllFunnelPages: false,
	funnelPage: 1,
	pageHistories: [],
	draggedElement: '',
	activeDropArea: '', // column key
	fontFamilies: [],
	sectionsCount: 0,
	isDragging: false,
	selectedElement: null,
	editorHistories: [],
};

const getters = {
	allFunnelPages: state => state.allFunnelPages,
	isFetchingFunnelPage: state => state.isFetchingFunnelPage,
	isFetchedFunnelPage: state => state.isFetchedFunnelPage,
	isAllFunnelPages: state => state.isAllFunnelPages,
	funnelPage: state => state.funnelPage,
	pageHistories: state => state.pageHistories,
	draggedElement: state => state.draggedElement,
	activeDropArea: state => state.activeDropArea,
	fontFamilies: state => state.fontFamilies,
	sectionsCount: state => state.sectionsCount,
	isDragging: state => state.isDragging,
	selectedElement: state => state.selectedElement,
	editorHistories: state => state.editorHistories,
};

const mutations = {
	[SET_FUNNEL_PAGES](state, funnelPages) {
		// const pages = funnelPages.map((page) => {
		// 	page.visitor = parseInt(Math.random() * 100);
		// 	page.average_visit_time = parseInt(Math.random() * 10);
		// 	return page;
		// });
		// state.allFunnelPages = pages;
		state.allFunnelPages = funnelPages;
	},
	[APPEND_FUNNEL_PAGE](state, funnelPages) {
		state.allFunnelPages = state.allFunnelPages.concat(funnelPages);
	},
	[APPEND_NEW_FUNNEL_PAGE](state, funnelPage) {
		const funnelPages = state.funnelPages;
		funnelPages.unshift(funnelPage);
		state.allFunnelPages = funnelPages;
	},
	[DELETE_FUNNEL_PAGE](state, index) {
		state.allFunnelPages.splice(index, 1);
	},
	[CLEAR_FUNNEL_PAGE](state) {
		state.allFunnelPages = [];
	},
	[RESET_FUNNEL_PAGES](state) {
		state.allFunnelPages = [];
		state.isAllFunnelPages = false;
		state.funnelPage = 1;
	},
	[SET_IS_FETCHING_FUNNEL_PAGE](state, status) {
		state.isFetchingFunnelPage = status;
	},
	[SET_IS_FETCHED_FUNNEL_PAGE](state, status) {
		state.isFetchedFunnelPage = status;
	},
	[ADD_FUNNEL_PAGE](state) {
		state.funnelPage++;
	},
	[SET_IS_ALL_FUNNEL_PAGE](state, isAll) {
		state.isAllFunnelPages = isAll;
	},
	[EDIT_FUNNEL_PAGES](state, funnel) {
		const index = state.isAllFunnelPages.findIndex(curr => curr._id === funnel._id);
		if (index !== -1) {
			state.isAllFunnelPages[index] = funnel;
		}
	},

	// page editor
	// eslint-disable-next-line
	[SET_PAGE_EDITOR_HISTORY](state, histories) {
		state.pageHistories = histories;
	},

	// on drag
	[SET_DRAGGED_ELEMENT](state, element) {
		state.draggedElement = element;
	},
	[SET_DROP_AREA](state, key) {
		state.activeDropArea = key;
	},

	// font family
	[SET_FONT_FAMILIES](state, fonts) {
		state.fontFamilies = fonts;
	},

	// sections
	[SET_SECTIONS_COUNT](state, count) {
		state.sectionsCount = count;
	},

	[SET_IS_DRAGGING](state, value) {
		state.isDragging = value;
	},

	[SET_ACTION_ELEMENT](state, value) {
		state.selectedElement = value;
	},
	// eslint-disable-next-line
	[APPEND_HISTOY](state, value) {
		state.pageHistories.unshift(value);
	},
};

const actions = {
	// cutomers
	// eslint-disable-next-line
	getFunnelPages({ commit, getters }, params) {
		if (!getters.isFetchingFunnelPage) {
			const defaultParams = {
				page: getters.page,
			};
			const fetchParams = Object.assign({}, defaultParams, params);
			commit(SET_IS_FETCHING_FUNNEL_PAGE, true);
			const callback = (response) => {
				const funnelPages = response.data;

				if (getters.allFunnelPages.length === 0) {
					commit(SET_FUNNEL_PAGES, funnelPages);
				} else if (funnelPages.length !== 0) {
					commit(APPEND_FUNNEL_PAGE, funnelPages);
				}

				if (funnelPages.length < params.limit) {
					commit(SET_IS_ALL_FUNNEL_PAGE, true);
				} else {
					commit(SET_IS_ALL_FUNNEL_PAGE, false);
				}

				commit(ADD_FUNNEL_PAGE);
				commit(SET_IS_FETCHING_FUNNEL_PAGE, false);
				commit(SET_IS_FETCHED_FUNNEL_PAGE, true);
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				console.log(msg);
				commit(SET_IS_FETCHING_FUNNEL_PAGE, false);
				commit(SET_IS_ALL_FUNNEL_PAGE, true);
				commit(SET_IS_FETCHED_FUNNEL_PAGE, true);
			};
			funnelsApi.getPages(fetchParams, callback, errorCallback);
		}
	},
	deleteFunnelPage({ commit }, index) {
		commit(DELETE_FUNNEL_PAGE, index);
	},
	setFunnelPage({ commit }, value) {
		commit(SET_FUNNEL_PAGE, value);
	},
	setIsAllFunnelPage({ commit }, isAll) {
		commit(SET_IS_ALL_FUNNEL_PAGE, isAll);
	},
	clearFunnelPages({ commit }) {
		commit(CLEAR_FUNNEL_PAGE);
	},
	resetFunnelPages({ commit }) {
		commit(RESET_FUNNEL_PAGES);
	},
	updateFunnelPage({ commit }, funnel) {
		commit(EDIT_FUNNEL_PAGES, funnel);
	},
	setPageEditorHistory({ commit }, history) {
		commit(SET_PAGE_EDITOR_HISTORY, history);
	},
	setDraggedElement({ commit }, element) {
		commit(SET_DRAGGED_ELEMENT, element);
	},
	setDropArea({ commit }, key) {
		commit(SET_DROP_AREA, key);
	},
	setFontFamilies({ commit }, fonts) {
		commit(SET_FONT_FAMILIES, fonts);
	},
	setSectionsCount({ commit }, count) {
		commit(SET_SECTIONS_COUNT, count);
	},
	setIsDragging({ commit }, value) {
		commit(SET_IS_DRAGGING, value);
	},
	appendPages({ commit }, newPages) {
		commit(APPEND_FUNNEL_PAGE, newPages);
	},
	setActionElement({ commit }, value) {
		commit(SET_ACTION_ELEMENT, value);
	},
	appendHistory({ commit }, history) {
		commit(APPEND_HISTOY, history);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
